import { makeStyles, Theme } from '@material-ui/core/styles'
import { IStyleProps } from './Interface'

export default makeStyles<Theme, IStyleProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: 10,
    transition: 'all 0.3s ease',
    '&:hover': {
      cursor: ({ edit }) => (edit ? 'cursor' : 'pointer'),
      borderRadius: 12,
      backgroundColor: theme.palette.common.lightGrey
    },
    '&:hover .pursuits-delete-button': {
      display: 'block !important'
    },
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 45,
      '& .pursuits-delete-button': {
        display: 'block !important'
      }
    }
  },
  rootDisabled: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: 10,
    transition: 'all 0.3s ease',
    cursor: 'cursor',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 30
    }
  },
  deleteButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    [theme.breakpoints.down('xs')]: {
      top: 'auto',
      bottom: 0
    }
  },
  hiddenDeleteButton: {
    display: 'none'
  },
  freeTextRoot: {
    display: 'flex'
  },
  titleInputContainer: {
    minWidth: 300,
    marginBottom: ({ edit }) => (edit ? 10 : 0),
    '&  p': {
      fontSize: 24,
      fontWeight: 500,
      color: ({ color }) => color
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: 'unset',
      width: '100%',
      '&  p': {
        fontSize: 18,
        paddingTop: 0
      }
    }
  },
  detailBox: {
    paddingLeft: 50,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0
    }
  },
  detailInputContainer: {
    width: '100%',
    '&  p': {
      fontWeight: 300,
      lineHeight: '40px',
      color: theme.palette.common.darkGrey
    },
    '& .MuiInputBase-root': {
      backgroundColor: '#fff'
    },
    [theme.breakpoints.down('xs')]: {
      '&  p': {
        fontSize: 12,
        lineHeight: '20px'
      }
    }
  },
  labelContainer: {
    '&  label': {
      color: theme.palette.common.lightBlue
    }
  }
}))
